import React from 'react';
import styled from 'styled-components';
import { Flex, getPaletteColor } from 'pcln-design-system';
const formatOffset = offset => {
  const type = typeof offset;
  switch (type) {
    case 'number':
      return `${offset}px`;
    case 'string':
    default:
      return offset;
  }
};
/** @public */
const FlexShadow = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "HighlightedFlex__FlexShadow",
  componentId: "sc-cnalqp-0"
})(["", " background:linear-gradient( ", ",", " );background-position:0px ", ";background-repeat:no-repeat;box-shadow:", " ", " 0px 0px ", ",-", " ", " 0px 0px ", ";margin-bottom:", ";"], props => !props.borderRadius && `border-radius: ${formatOffset(props.shadowOffsetX)};`, props => getPaletteColor(props.shadowColor || 'primary.light', 'base'), props => getPaletteColor(props.shadowColor || 'primary.light', 'base'), props => formatOffset(props.shadowOffsetY), props => formatOffset(props.shadowOffsetX) || '10px', props => formatOffset(props.shadowOffsetY), props => getPaletteColor(props.shadowColor || 'primary.light', 'base'), props => formatOffset(props.shadowOffsetX), props => formatOffset(props.shadowOffsetY), props => getPaletteColor(props.shadowColor || 'primary.light', 'base'), props => formatOffset(props.shadowOffsetY));
/** @public */
const HighlightedFlex = ({
  children,
  ...props
}) => {
  return React.createElement(FlexShadow, {
    ...props
  }, children);
};
HighlightedFlex.defaultProps = {
  shadowOffsetX: 10,
  shadowOffsetY: 30,
  shadowColor: 'primary.light'
};
/** @public */
export { HighlightedFlex };